var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrafficLightRecognition32 = function SvgTrafficLightRecognition32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.771 10.697c.002.239-.042.476-.13.698a1.664 1.664 0 0 1-.929.933 2.092 2.092 0 0 1-1.612-.055 1.741 1.741 0 0 1-.62-.532 2.33 2.33 0 0 1-.364-.794 3.751 3.751 0 0 1-.115-.933 3.405 3.405 0 0 1 .123-.972c.082-.287.216-.556.397-.794.182-.234.415-.423.682-.552.303-.14.635-.207.969-.195a2.35 2.35 0 0 1 .83.143c.237.085.454.22.634.397l-.527.608a1.736 1.736 0 0 0-.465-.25 1.628 1.628 0 0 0-.516-.092 1.191 1.191 0 0 0-.905.37 1.45 1.45 0 0 0-.369.944 1.19 1.19 0 0 1 .496-.425 1.66 1.66 0 0 1 .715-.15c.23-.001.459.04.674.123.2.076.384.19.54.337.156.146.28.323.361.52.09.212.135.44.131.67Zm-.885.028a.92.92 0 0 0-.258-.683.949.949 0 0 0-.663-.258 1.032 1.032 0 0 0-.369.063.832.832 0 0 0-.492.489 1.01 1.01 0 0 0-.071.396c-.003.136.022.271.071.397a.825.825 0 0 0 .488.485 1.033 1.033 0 0 0 .735 0 .825.825 0 0 0 .492-.484 1.04 1.04 0 0 0 .067-.405ZM18.344 7.5c.3-.005.597.057.87.183.254.118.478.294.654.512.182.237.317.506.397.794.098.33.147.672.143 1.016.003.34-.047.68-.15 1.004a2.3 2.3 0 0 1-.425.794 1.912 1.912 0 0 1-1.517.683 2.076 2.076 0 0 1-.877-.179 1.847 1.847 0 0 1-.65-.508 2.295 2.295 0 0 1-.398-.794 3.345 3.345 0 0 1-.143-1.008 3.148 3.148 0 0 1 .155-1.012c.09-.29.234-.559.425-.794.18-.216.407-.39.663-.508.267-.123.559-.186.853-.183Zm0 4.176a1.016 1.016 0 0 0 .885-.44 2.687 2.687 0 0 0 0-2.497 1.016 1.016 0 0 0-.88-.445 1.056 1.056 0 0 0-.898.445c-.237.375-.35.815-.322 1.258a2.06 2.06 0 0 0 .322 1.242 1.056 1.056 0 0 0 .893.437Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.298,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 17a7 7 0 1 0 0-14 7 7 0 0 0 0 14Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m20.5 22 2.5-2m0 0 2.5 2M23 20v6",
    stroke: "currentColor",
    strokeWidth: 1.85,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23 30a7 7 0 1 0 0-14 7 7 0 0 0 0 14Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9 30a7 7 0 1 0 0-14 7 7 0 0 0 0 14Zm4.5-12-9 9",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgTrafficLightRecognition32;